/* Scroll reveal: shared setup (moved out of snippets/scroll-reveal.liquid,
   2026-10-07, unchanged apart from where its inputs come from). The snippet used
   to inline this ~7KB once per section, 9 times on the homepage; it now loads
   once from this cached file. Each section's inline part still registers its id
   (window.__srRoots), and the first one sets window.__srSel (the target list
   the CSS is built from), window.__srScope, window.__srInit and, in the theme
   editor, html.sr-off. This file is loaded with defer, so it runs right before
   DOMContentLoaded, which is when the inline version started anyway. */
(function () {
  if (window.__srBooted) return;
  window.__srBooted = true;
  if (window.Shopify && window.Shopify.designMode) return;
  var SEL = window.__srSel;
  if (!SEL) return;


    function roots() {
      if (window.__srScope === 'main') {
        var m = document.querySelector('main');
        return m ? [m] : [];
      }
      if (window.__srScope === 'template') {
        return [].slice.call(document.querySelectorAll('main .shopify-section'));
      }
      var ids = window.__srRoots || [], out = [];
      for (var i = 0; i < ids.length; i++) {
        var sec = document.getElementById('shopify-section-' + ids[i]);
        if (sec) out.push(sec);
      }
      return out;
    }

    function allPieces() {
      var secs = roots(), out = [];
      for (var i = 0; i < secs.length; i++) {
        var found = secs[i].querySelectorAll(SEL);
        for (var k = 0; k < found.length; k++) out.push(found[k]);
      }
      return out;
    }

    function revealAll() {
      var all = allPieces();
      for (var i = 0; i < all.length; i++) all[i].classList.add('sr-in');
    }

    /* How far down the viewport a piece's top edge must reach before it plays.
       0.88 means it starts just as the piece comes into view. */
    var TRIGGER = 0.88;

    var pending = [];   /* individual pieces not yet played */
    var armed = false;  /* has layout settled enough for a rect to mean anything */
    var ticking = false;

    function raf(f) {
      return (window.requestAnimationFrame || function (g) { return setTimeout(g, 16); })(f);
    }

    /* Reveal, without animating, everything already above the trigger line when
       the page settles. See PRIMING in the header: this is what keeps a
       collection grid's first row out of the animation and off the LCP path. */
    function prime() {
      var h = window.innerHeight || document.documentElement.clientHeight;
      var now = [];
      for (var i = pending.length - 1; i >= 0; i--) {
        if (pending[i].getBoundingClientRect().top < h * TRIGGER) {
          now.push(pending[i]);
          pending.splice(i, 1);
        }
      }
      if (!now.length) return;
      for (var k = 0; k < now.length; k++) {
        now[k].classList.add('sr-now');
        now[k].classList.add('sr-in');
      }
      /* Two frames: one for the shown state to paint with transitions off, then
         drop the suppression so these behave normally from here. If frames never
         come (a background tab) they simply stay visible, which is correct. */
      raf(function () {
        raf(function () {
          for (var k = 0; k < now.length; k++) now[k].classList.remove('sr-now');
        });
      });
    }

    function sweep() {
      ticking = false;
      if (!armed) return;
      var h = window.innerHeight || document.documentElement.clientHeight;
      /* Backwards, so splicing out a played piece cannot skip its neighbour. */
      for (var i = pending.length - 1; i >= 0; i--) {
        var el = pending[i];
        var r = el.getBoundingClientRect();
        /* Deliberately NO `&& r.bottom > 0`. Requiring the piece to still be on
           screen stranded anything the reader had already gone past: reloading
           while scrolled down, a back navigation, an anchor link, or a fast
           flick all left that content invisible permanently, which is the one
           genuinely bad outcome this whole file is built to avoid. Once a piece
           has crossed the trigger line its animation is owed. */
        if (r.top < h * TRIGGER) {
          el.classList.add('sr-in');
          pending.splice(i, 1);
        }
      }
    }

    function request() {
      if (ticking) return;
      ticking = true;
      raf(function () {
        /* Failure mode 4. A thrown sweep would otherwise leave the page hidden
           for good, so this is the one place that gives up and shows all. */
        try { sweep(); } catch (e) { ticking = false; revealAll(); }
      });
    }

    function arm() {
      if (armed) return;
      armed = true;
      try { prime(); } catch (e) { revealAll(); return; }
      request();
    }

    /* Layout can change with no scroll and no resize. The collection filters
       show and hide cards, and a filtered grid was leaving cards that had moved
       up into view still sitting at opacity 0 until the shopper happened to
       scroll: measured on /collections/all, filtering to "Under $150" left 2 of
       the 4 cards in the viewport invisible, with scroll and resize both firing
       zero times.

       ResizeObserver on the roots catches it precisely, because dropping cards
       changes the grid's height. The click and change listeners in capture
       cover the rarer case where the height happens not to move, and any other
       control that reflows without scrolling. All three funnel into request(),
       already throttled to one sweep per frame, so the cost is one rect read
       per still-pending piece. */
    function watchLayout() {
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(request);
        var rs = roots();
        for (var i = 0; i < rs.length; i++) ro.observe(rs[i]);
      }
      document.addEventListener('click', request, true);
      document.addEventListener('change', request, true);
    }

    function start() {
      pending = allPieces();
      if (!pending.length) return;

      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request);
      watchLayout();

      /* Nothing is measured until the page has finished loading, because that is
         the point at which the images above have taken their final height and a
         rect finally means what it says. */
      if (document.readyState === 'complete') {
        arm();
      } else {
        window.addEventListener('load', arm);
      }

      /* Backstop for a hung third party asset holding up window.load. This only
         lets the sweep start measuring; it reveals nothing by itself. */
      setTimeout(arm, 6000);
    }

    /* Deferred to DOMContentLoaded because this runs from the FIRST section on
       the page, and the later ones have not registered themselves yet. */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
